import type { FaireProductEntity } from "../../entity_types/product";

export const p_85mhrm3stk: FaireProductEntity = {
  token: "p_85mhrm3stk",
  type: "product",
  name: "Hair Wax Stick",
  brandToken: "b_dljmfs9o",
  brandName: "KITSCH",
  imageUrl:
    "https://cdn.faire.com/fastly/82f75c4f1e68cd401bd3b5e5087dfa3c7b34059bd1b26ba5d3ee280d248cbbd3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b166cb65dd6c8642f0065d16e84d01842195aac29ccb79b405d9297779feffa1.jpeg",
    "https://cdn.faire.com/fastly/4ef2f6a99537bde13918e25c1e4752936b0179a05473d53be92dbdce8bd58828.jpeg",
    "https://cdn.faire.com/fastly/5c3b2f21dd101cb0f58ba3cbb58a143afd39e69ab9f3271d2fb87071e724cf4a.jpeg",
    "https://cdn.faire.com/fastly/155a23a835c2f30a09343ec23c93d5f677e25be5eb4ed1d9d6d576caf25e7025.jpeg",
    "https://cdn.faire.com/fastly/d05dbbc874907162f30265284154efeb6c17a2673fe37fb58b8bf14d5b957974.jpeg",
    "https://cdn.faire.com/fastly/003ac83c015c6ded83bf09ac24683a09b882b58855598b19a69ee462d5ce30c1.jpeg",
  ],
  priceDollars: 7,
  description:
    "- 100% vegan & plant-based wax stick enriched with nourishing castor oil\n- Tames stubborn strands for a sleek & polished style\n- Effortlessly smooths hair with a convenient solid stick design for touch-ups on the go\n\n- No-residue formula is easy to comb through, re-style & wash out\n- All-day hold locks your look in place without texture or greasiness \n- Packaging is made from biodegradable FSC-certified paper\n- Made in the USA, Vegan, Cruelty-Free, Leaping Bunny Certified",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:14.900Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
